module.exports = __webpack_public_path__ + "static/img/zice.71a7cc71.gif";